/**********************************************************************************************************
*   BASE IMPORTS
**********************************************************************************************************/
import { useDispatch } from 'react-redux'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Lightbox } from '@nexigendigital/nxui'
import { setSupportOpen } from 'store/slices/supportSlice'
import { useAppSelector } from 'store/hooks'

import SupportForm from 'containers/support/form/supportForm'

/**********************************************************************************************************
*   COMPONENT START
**********************************************************************************************************/
export default function Support() {
    const dispatch = useDispatch()
    const { supportOpen } = useAppSelector((state) => state.support)

    const conditionalProps = {
        title: 'Support Request',
        content: <SupportForm />,
        conditions: { state: supportOpen, action: () => dispatch(setSupportOpen(false)) },
        actions: [
            {
                label: 'Submit Ticket',
                color: 'primary',
                disabled: false,
                type: 'submit',
                func: () => { }
            }
        ]
    }

    return (
        <Lightbox {...conditionalProps} close={() => dispatch(setSupportOpen(false))} />
    )
}
